import dayjs from 'dayjs';

export function isActive({ startDate, endDate }: { startDate: string; endDate: string }): boolean {
  const now = dayjs().startOf('day');
  const hasStarted = now.isAfter(startDate) || now.isSame(startDate);
  const hasNotEnded = !endDate || now.isBefore(endDate) || now.isSame(endDate);

  return hasStarted && hasNotEnded;
}
